// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23XyA","title":"styles_title__1h6E_"};